<!-- <p>
  customer-adjustment works!
</p> -->

<app-adjustment-forms [disableSubmit]="disableSubmit" [info]="info" [success]="success" (adjustmentDetails)="peformAdjustment($event)" (changeRows)="changeRows($event)"></app-adjustment-forms>

